'use client'

import { usePathname } from 'next/navigation'
import { ReactNode } from 'react'

import ChunkErrorRecovery from '@/common/components/ChunkErrorRecovery'
// Parche al DateInput de Kendo (Bug 43060): tiene que evaluarse antes de que se cree el primer DatePicker.
import '@/common/helpers/parcheDateInputKendo'
import { esRutaPuenteMsal } from '@/core/msal/rutasPuente'
import ConfigAppContainer from '@/core/providers/ConfigAppContainer/ConfigAppContainer'
import ConfigAppInsightsContainer from '@/core/providers/ConfigAppInsightsContainer/ConfigAppInsightsContainer'
import ConfigLanguageContainer from '@/core/providers/ConfigLanguageContainer/ConfigLanguageContainer'
import ConfigMsalContainer from '@/core/providers/ConfigMsalContainer/ConfigMsalContainer'
import ConfigNotificationProvider from '@/core/providers/ConfigNotificationProvider/ConfigNotificationProvider'
import ConfigReduxContainer from '@/core/providers/ConfigReduxContainer/ConfigReduxContainer'
import ConfigRuntimeProvider from '@/core/providers/ConfigRuntimeProvider/ConfigRuntimeProvider'
import ConfigStyledComponentsProvider from '@/core/providers/ConfigStyledComponentsProvider/ConfigStyledComponentsProvider'

interface IConfigRootProvidersProps {
  children: ReactNode
}

const ConfigRootProviders: React.FC<IConfigRootProvidersProps> = ({ children }) => {
  const pathname = usePathname()

  // Las páginas puente de MSAL v5 (/redirect y el relevo del popup /popup-relay) deben correr sin
  // providers (sin MsalProvider ni routing extra) para que procesen el hash de autenticación sin
  // interferencias
  if (esRutaPuenteMsal(pathname)) {
    return <>{children}</>
  }

  return (
    <ConfigStyledComponentsProvider>
      <ChunkErrorRecovery />
      <ConfigRuntimeProvider>
        <ConfigReduxContainer>
          <ConfigAppInsightsContainer>
            <ConfigLanguageContainer>
              <ConfigMsalContainer>
                <ConfigAppContainer>
                  <ConfigNotificationProvider>{children}</ConfigNotificationProvider>
                </ConfigAppContainer>
              </ConfigMsalContainer>
            </ConfigLanguageContainer>
          </ConfigAppInsightsContainer>
        </ConfigReduxContainer>
      </ConfigRuntimeProvider>
    </ConfigStyledComponentsProvider>
  )
}

export default ConfigRootProviders
